import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { COLLECTION } from '../../constants/collection';
import ManageEventsBody from './ManageEventsBody/ManageEventsBody';
import ManageEventsSidebar from './ManageEventsSidebar/ManageEventsSidebar';
import PageHeader from '../../components/PageHeader/PageHeader';
import { setActiveManageEventId } from '../../redux/actions/activeManageEventId';
import Style from '../../styles/common';
import { withFirestore } from 'react-redux-firebase';

const Container = styled('div')`
  height: 100%;
`;

const Body = styled('div')`
  border-top: 2px solid ${Style.color.listDivider};
  display: flex;
  flex-grow: 1;
  min-height: calc(100% - ${Style.MEASUREMENT.VIEW.HEADER});
`;

class ManageEvents extends React.Component {
  static propTypes = {
    activeManageEventId: PropTypes.string,
    authUser: PropTypes.object.isRequired,
    setActiveManageEventId: PropTypes.func.isRequired,
    status: PropTypes.object,
    userEvents: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  static defaultProps = {
    activeManageEventId: '',
    status: {},
  };

  componentDidUpdate() {
    this.subscribeToUserEvents();
  }

  componentDidMount() {
    this.subscribeToUserEvents();
  }

  componentWillUnmount() {
    this.props.setActiveManageEventId('');
  }

  subscribeToUserEvents = () => {
    if (
      this.props.authUser.isLoaded &&
      this.query &&
      !this.props.allListenersIds.includes(this.query) &&
      !this.isRequesting
    ) {
      this.props.firestore.onSnapshot({
        collection: COLLECTION.EVENTS,
        where: ['owner', '==', this.props.authUser.uid],
        storeAs: 'userEvents',
      });
    }
  };

  render() {
    return (
      <Container>
        <PageHeader>Manage my events</PageHeader>
        <Body>
          <ManageEventsSidebar
            activeEventId={this.props.activeManageEventId}
            events={this.props.userEvents}
            onClick={this.props.setActiveManageEventId}
          />
          <ManageEventsBody
            activeEvent={this.activeEvent}
            events={this.props.userEvents}
            isEmpty={this.props.userEvents.length === 0}
            isRequesting={this.isRequesting}
          />
        </Body>
      </Container>
    );
  }

  get isRequesting() {
    if (!this.props.authUser.isLoaded) {
      return true;
    }

    return this.props.status.requesting[this.query];
  }

  get activeEvent() {
    if (this.props.userEvents.length === 0) {
      return {};
    }

    const activeEvent = this.props.userEvents.find(event => {
      return this.props.activeManageEventId === event.id;
    });

    if (!activeEvent) {
      const firstEvent = this.props.userEvents[0];
      this.props.setActiveManageEventId(firstEvent.id);
      return firstEvent;
    }

    return activeEvent;
  }

  get query() {
    const { uid } = this.props.authUser;

    if (!uid) {
      return null;
    }

    return `${COLLECTION.EVENTS}?where=owner:==:${uid}`;
  }
}

export default compose(
  withFirestore,
  connect(
    state => ({
      activeManageEventId: state.activeManageEventId,
      allListenersIds: state.firestore.listeners.allIds,
      authUser: state.firebase.auth,
      status: state.firestore.status,
      userEvents: state.firestore.ordered.userEvents || [],
    }),
    { setActiveManageEventId },
  )
)(ManageEvents);



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEvents.js